export default [
  {
    path: '/pages/:categoryId?',
    name: 'webPages#index',
    component: () => import('@views/webPages/index'),
    meta: {
      header: true,
    },
  },
  {
    path: '/pages/:categoryId/:webPageId',
    name: 'webPages#show',
    component: () => import('@views/webPages/show'),
    meta: {
      header: true,
    },
  },
  {
    path: '/page',
    name: 'webPages#single',
    component: () => import('@views/webPages/show'),
    meta: {
      header: true,
    },
  },
];
